module.exports = __webpack_public_path__ + "static/logo-greenpeace-d1e7599f2de897424d977b5d5e25cdf9.png";